import API from './startupAPI';

import {
  GET_STARTUP_LISTING_DATA,
} from '../../types';

export const StartupListing = () => async (dispatch) => {
  const startupListings = await API.getStartupListing();
  dispatch({
    type: GET_STARTUP_LISTING_DATA,
    payload: startupListings[0],
  });
};

export default StartupListing;
